import(/* webpackMode: "eager", webpackExports: ["Flex"] */ "/usr/app/node_modules/@chakra-ui/react/dist/esm/components/flex/flex.js");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/usr/app/src/app/[locale]/(restaurant)/restaurant/[id]/ui/header/ui/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/widgets/bottom-navigation/ui/bottom-navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/widgets/brands/ui/brands-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/widgets/category-filters/ui/category-filters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroBanner"] */ "/usr/app/src/widgets/hero-banner/ui/hero-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/widgets/map/index.tsx");
